export enum AccessRole {
  MUSA = "musa",
  ADMIN = "admin",
  HAULER_ADMIN = "hauler_admin",
}
